import { SVGProps, Ref, forwardRef } from 'react';

export const LabelUserFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 12C1 6.5 3.75 1 12 1s11 5.5 11 11-2.75 11-11 11S1 17.5 1 12m7.583-3.218c0-1.709.854-3.417 3.417-3.417s3.417 1.708 3.417 3.417-.854 3.416-3.417 3.416-3.417-1.708-3.417-3.416M12 13.44c2.499 0 4.998 1.117 5.5 4.349h-11c.502-3.232 3.001-4.35 5.5-4.35"
            fill="currentColor"
        />
    </svg>
));
LabelUserFilledSize24Glyph.displayName = 'LabelUserFilledSize24Glyph';
